import html2pdf from "html2pdf.js";

import logo from "../Assets/Logos/yostel.svg";
import { toWords } from "number-to-words";

// Function to format date
function formatDate(dateString) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

//Function to generate receipt number
function generateReceiptNumber(companyCode) {
  const date = new Date();
  const formattedDate =
    date.getFullYear().toString().slice(-2) +
    String(date.getMonth() + 1).padStart(2, "0") +
    String(date.getDate()).padStart(2, "0");

  const uniqueId = Math.floor(10000 + Math.random() * 90000); // Random 5-digit number

  return `${companyCode}-${formattedDate}-${uniqueId}`;
}

// const formatDateISOdates = (isoDateString) => {
//   if (!isoDateString) return "";

//   const date = new Date(isoDateString);
//   if (isNaN(date.getTime())) return "Invalid Date";

//   const day = String(date.getUTCDate()).padStart(2, "0");
//   const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-indexed
//   const year = date.getUTCFullYear();

//   return `${day}-${month}-${year}`;
// };
// const generateReceipt = async (data) => {
//   const currentDate = formatDate(new Date());
//   const receiptNo = generateReceiptNumber("Yostel");
//   const nameOfFile = `${data?.tenantName}-receipt` || "Invoice";
//   console.log("nameOfFile--->", nameOfFile);

//   let htmlContent;
//   // if (status === "revise" || status === "Pending") {
//   htmlContent = `<!DOCTYPE html>
// <html lang="en">
//   <head>
//     <meta charset="UTF-8" />
//     <meta name="viewport" content="width=device-width, initial-scale=1.0" />
//     <title>Tax Invoice</title>
//     <style>
//       body {
//         font-family: Arial, sans-serif;
//         margin: 0;
//         padding: 0;
//         background: #f8f8f8;
//       }

//       .invoice-container {
//         max-width: 900px;
//         margin: 30px auto;
//         padding: 20px;
//         background: #fff;
//         border: 1px solid #ddd;
//         box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//         border-radius: 8px;
//       }

//       .header {
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         border-bottom: 2px solid #235784;
//         padding-bottom: 16px;
//         padding: 16px;
//       }

//       .header .company-details h1 {
//         font-size: 22px;
//         margin: 0;
//         color: #333;
//       }

//       .header .company-details p {
//         font-size: 14px;
//         margin: 5px 0;
//         color: #555;
//       }

//       .payment-receipt {
//         text-align: center;
//         font-size: 18px;
//         margin-top: 16px;
//         font-weight: bold;
//         color: #333;
//         letter-spacing: 1px;
//       }

//       .footer {
//         margin-top: 15px;
//         margin-bottom: 40px;
//         font-size: 12px;
//         padding: 4px 24px;
//         color: #555;
//         display: flex;
//         align-items: flex-end;
//         justify-content: space-between;
//         text-align: right;
//       }

//       .footer p {
//         margin: 5px 0;
//       }

//       .footer .bank-details {
//         margin-top: 10px;
//       }

//       .footer .bank-details p {
//         margin: 3px 0;
//       }

//       .signature {
//         /* margin-top: 20px; */
//         text-align: right;
//         font-size: 14px;
//         font-weight: bold;
//         color: #000;
//         float: right;
//       }

//       .signature-container {
//         display: flex;
//         flex-direction: column;
//         align-items: flex-end;
//         justify-content: flex-end;
//         text-align: right;
//         font-size: 14px;
//         font-weight: bold;
//       }

//       .logoImg {
//         height: auto;
//         width: 160px;
//       }

//       .bankInfo {
//         text-align: start;
//       }

//       .tenant-details {
//         display: flex;
//         flex-direction: row;
//         justify-content: space-between;
//         font-size: 14px;
//         letter-spacing: 1px;
//         padding: 4px 24px;
//       }

//       .tenant-details p {
//         font-weight: 600;
//         margin: 8px 0;
//       }

//       .tenant-details span {
//         font-weight: 400;
//       }

//       .receipt-body {
//         padding: 4px 24px;
//         font-size: 16px;
//         line-height: 0.7cm;
//       }

//       .receipt-body span {
//         font-weight: 600;
//       }

//       .tenant-name {
//         font-weight: bold;
//       }

//       .in-words {
//         font-weight: 100;
//         font-style: italic;
//       }
//     </style>
//   </head>
//   <body>
//     <div class="invoice-container">
//       <!-- Header Section -->
//       <div class="header">
//         <div class="">
//           <img class="logoImg" src=${logo} alt="Yostel Logo" />
//         </div>
//         <div class="company-details">
//           <h1>YOSTEL PG MANAGEMENT,</h1>
//           <p>Plot no 1472 P, Sastrinagar Square,</p>
//           <p>Main Road, Near SBI Colony Unit-4,</p>
//           <p>Bhubaneswar, Odisha 751001,</p>
//           <p>GSTIN: 21DLMPS6205K1ZV</p>
//         </div>
//       </div>

//       <!-- Receipt Title -->
//       <div class="payment-receipt">PAYMENT RECEIPT</div>

//       <!-- Tenant Details  -->
//       <div class="tenant-details">
//         <div class="">
//           <p>Name - <span>${data?.tenantName}</span></p>
//           <p>Building Name - <span>${data?.buildingName}</span></p>
//           <p>Room No - <span>${data?.roomNo}</span></p>
//         </div>

//         <div>
//           <p>Receipt No. - <span>${receiptNo}</span></p>
//           <p>Date - <span>${currentDate}</span></p>
//         </div>
//       </div>

//       <!-- Receipt Body  -->
//       <div class="receipt-body">
//         <p>Dear <span class="tenant-name">Aditya Kumar Behera</span></p>
//         <p>
//           We have successfully received your payment of
//           <span>Rs.${data?.amount || 0}</span>
//           <span class="in-words">(${toWords(data?.amount || 0)})</span> by
//           <span>${data?.paymentMode}</span> on behalf of <span>${
//     data?.paymentType
//   }</span> on the date
//           ${currentDate}
//         </p>
//         <p>
//           Your Outstanding Amount is <span>Rs. ${
//             data?.amountOutstanding
//           }</span> <br />
//           Thank you for choosing us.
//         </p>
//       </div>

//       <!-- Footer Section -->
//       <div class="footer">
//         <div class="bankInfo">
//           <div class="bank-details">
//             <p>
//               <strong>Bank Details:</strong>
//             </p>
//             <p>
//               <span style="font-weight: 600">Account Name:</span> Yostel PG
//               Management
//             </p>
//             <p>Bank: SBI | Account Number: 38939485103</p>
//             <p>IFSC Code: SBIN0051302</p>
//             <br />
//             <p className="mt-3">
//               <span style="font-weight: 600">Account Name:</span> Jagannath
//               Tours & Travels
//             </p>
//             <p>Bank: AXIS | Account Number: 922020022232929</p>
//             <p>IFSC Code: UTIB0003089</p>
//           </div>
//         </div>

//         <!-- Signature -->
//         <div class="signature-container">
//           <p class="signature">${data?.receiver}</p>
//           <p>Received By</p>
//         </div>
//       </div>
//     </div>
//   </body>
// </html>
// `;

//   let pdfstring;
//   try {
//     const options = {
//       margin: 0.3,
//       filename: `${nameOfFile}.pdf`,
//       image: { type: "svg", quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
//     };

//     const pdfData = await html2pdf()
//       .from(htmlContent)
//       .set(options)
//       .outputPdf("datauristring"); //Converts the PDF into base-64 string

//     pdfstring = pdfData.split(",")[1];
//     console.log("pdf generated successfully..");
//     return pdfstring;
//   } catch (error) {
//     console.log(error);
//   }
// };

const generateReceipt = async (data) => {
  return new Promise((resolve, reject) => {
    try {
      const currentDate = formatDate(new Date());
      const receiptNo = generateReceiptNumber("YOSTEL");
      const nameOfFile = `${data?.tenantName}-receipt` || "Receipt";
      console.log("Generating PDF for:", nameOfFile);

      const htmlContent = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Payment Receipt</title>
    <style>
      body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
      }

      .invoice-container {
        max-width: 900px;
        margin: 30px auto;
        padding: 20px;
        background: #fff;
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #235784;
        padding-bottom: 16px;
        padding: 16px;
      }

      .header .company-details h1 {
        font-size: 22px;
        margin: 0;
        color: #333;
      }

      .header .company-details p {
        font-size: 14px;
        margin: 5px 0;
        color: #555;
      }

      .payment-receipt {
        text-align: center;
        font-size: 18px;
        margin-top: 16px;
        font-weight: bold;
        color: #333;
        letter-spacing: 1px;
      }

      .footer {
        margin-top: 15px;
        margin-bottom: 40px;
        font-size: 12px;
        padding: 4px 24px;
        color: #555;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        text-align: right;
      }

      .footer p {
        margin: 5px 0;
      }

      .footer .bank-details {
        margin-top: 10px;
      }

      .footer .bank-details p {
        margin: 3px 0;
      }

      .signature {
        /* margin-top: 20px; */
        text-align: right;
        font-size: 14px;
        font-weight: bold;
        color: #000;
        
      }

      .signature-container {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        text-align: right;
        font-size: 14px;
        font-weight: bold;
      }

      .logoImg {
        height: auto;
        width: 160px;
      }

      .bankInfo {
        text-align: start;
      }

      .tenant-details {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 14px;
        letter-spacing: 1px;
        padding: 4px 24px;
      }

      .tenant-details p {
        font-weight: 600;
        margin: 8px 0;
      }

      .tenant-details span {
        font-weight: 400;
      }

      .receipt-body {
        padding: 4px 24px;
        font-size: 16px;
        line-height: 0.7cm;
      }

      .receipt-body span {
        font-weight: 600;
      }

      .tenant-name {
        font-weight: bold;
      }

      .in-words {
        font-weight: 100;
        font-style: italic;
      }
    </style>
  </head>
  <body>
    <div class="invoice-container">
      <!-- Header Section -->
      <div class="header">
        <div class="">
          <img class="logoImg" src=${logo} alt="Yostel Logo" />
        </div>
        <div class="company-details">
          <h1>YOSTEL PG MANAGEMENT,</h1>
          <p>Plot No 65, Janpath,</p>
          <p>Unit-2, Kalinga Nagar</p>
          <p>Bhubaneswar, Odisha-751007</p>
        </div>
      </div>

      <!-- Receipt Title -->
      <div class="payment-receipt">PAYMENT RECEIPT</div>

      <!-- Tenant Details  -->
      <div class="tenant-details">
        <div class="">
          <p>Name - <span>${data?.tenantName}</span></p>
          <p>Building Name - <span>${data?.buildingName}</span></p>
          <p>Room No - <span>${data?.roomNo}</span></p>
        </div>

        <div>
          <p>Receipt No. - <span>${receiptNo}</span></p>
          <p>Date - <span>${currentDate}</span></p>
        </div>
      </div>

      <!-- Receipt Body  -->
      <div class="receipt-body">
        <p>Dear <span class="tenant-name">Aditya Kumar Behera</span></p>
        <p>
          We have successfully received your payment of
          <span>Rs.${data?.amount}</span>
          <span class="in-words">(Rs.${toWords(
            data?.amount || 0
          )} only)</span> by
          <span>${data?.paymentMode}</span> on behalf of <span>${
        data?.paymentType
      }</span> on the date
          ${currentDate}
        </p>
        <p>
          Your Outstanding Amount is <span>Rs. ${
            data?.amountOutstanding
          }</span> <br />
          Thank you for choosing us.
        </p>
      </div>

      <!-- Footer Section -->
      <div class="footer">
        <div class="bankInfo">
          <div class="bank-details">
            <p>
              <strong>Bank Details:</strong>
            </p>
            <p>
              <span style="font-weight: 600">Account Name:</span> Yostel PG
              Management
            </p>
            <p>Bank: SBI | Account Number: 38939485103</p>
            <p>IFSC Code: SBIN0051302</p>
            <br />
            <p className="mt-3">
              <span style="font-weight: 600">Account Name:</span> Yostel PG Management
            </p>
            <p>Bank: AXIS | Account Number: 922020022232929</p>
            <p>IFSC Code: UTIB0003089</p>
          </div>
        </div>

        <!-- Signature -->
        <div class="signature-container">
          <p class="signature">${data?.receiver}</p>
          <p>Received By</p>
        </div>
      </div>
    </div>
  </body>
</html>`;

      const options = {
        margin: 0.3,
        filename: `${nameOfFile}.pdf`,
        image: { type: "svg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .from(htmlContent)
        .set(options)
        .outputPdf("datauristring")
        .then((pdfData) => {
          console.log("PDF successfully generated!");
          const pdfString = pdfData.split(",")[1]; // Extract base64
          resolve(pdfString);
        })
        .catch((err) => {
          console.error("Error generating PDF:", err);
          reject(err);
        });
    } catch (error) {
      console.error("Unexpected error in generateReceipt:", error);
      reject(error);
    }
  });
};

export default generateReceipt;
